const IMPACT_ORDER = { high: 0, medium: 1, low: 2 };
const CATEGORY_ORDER = ["content", "technical", "schema", "social", "tools"];

export function suggestionKinds(actions) {
  const present = new Set(
    (actions || []).map((action) => action.category).filter(Boolean),
  );
  const known = CATEGORY_ORDER.filter((name) => present.has(name));
  const rest = [...present]
    .filter((name) => !CATEGORY_ORDER.includes(name))
    .sort();
  return [...known, ...rest];
}

const BUCKETS = [
  { id: "this-week", label: "This week", impact: "high" },
  { id: "next-week", label: "Next week", impact: "medium" },
  { id: "later", label: "Later", impact: "low" },
];

export function sortReportActions(actions) {
  return [...(actions || [])]
    .map((action, index) => ({ action, index }))
    .sort((a, b) => {
      const impact =
        (IMPACT_ORDER[a.action.impact] ?? 3) -
        (IMPACT_ORDER[b.action.impact] ?? 3);
      if (impact !== 0) return impact;
      return a.index - b.index;
    })
    .map((item) => item.action);
}

function groupByCategory(actions) {
  const grouped = new Map();
  actions.forEach((action) => {
    const name = action.category || "other";
    if (!grouped.has(name)) grouped.set(name, []);
    grouped.get(name).push(action);
  });

  const rank = (name) => {
    const index = CATEGORY_ORDER.indexOf(name);
    return index === -1 ? CATEGORY_ORDER.length : index;
  };

  return [...grouped.entries()]
    .sort((a, b) => rank(a[0]) - rank(b[0]) || a[0].localeCompare(b[0]))
    .map(([name, items]) => ({
      name: name.charAt(0).toUpperCase() + name.slice(1),
      actions: items,
    }));
}

export function presentActions(actions) {
  const sorted = sortReportActions(actions);
  const lead = sorted.slice(0, 10);
  const rest = sorted.slice(10);
  const groups = BUCKETS.map((bucket) => {
    const items = rest.filter(
      (action) => (action.impact || "medium") === bucket.impact,
    );
    return {
      ...bucket,
      count: items.length,
      categories: groupByCategory(items),
    };
  }).filter((group) => group.count > 0);

  return { lead, groups };
}

function proseBlocks(markdown) {
  return String(markdown || "")
    .replace(/```[\s\S]*?```/g, "")
    .replace(/^#{1,6}\s+.*$/gm, "")
    .split(/\n\s*\n/)
    .map((block) =>
      block
        .replace(/\*\*(.*?)\*\*/g, "$1")
        .replace(/\[(.*?)\]\(.*?\)/g, "$1")
        .replace(/\s+/g, " ")
        .trim(),
    )
    .filter((block) => block && !block.startsWith("|") && !/^[-*]\s/.test(block));
}

function sentencesOf(paragraph) {
  return paragraph
    .split(/(?<=[.!?]["']?)\s+/)
    .map((sentence) => sentence.trim())
    .filter(Boolean);
}

export function briefFromSummary(markdown) {
  const blocks = proseBlocks(markdown);
  if (blocks.length === 0) {
    return { brief: "", hasMore: Boolean(String(markdown || "").trim()) };
  }

  const sentences = sentencesOf(blocks[0]);
  const brief = sentences.slice(0, 3).join(" ");
  const hasMore = sentences.length > 3 || blocks.length > 1;
  return { brief, hasMore };
}
